import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

/**
 * HomeLayout component - Layout for homepage without footer
 * 
 * @returns React component for the home layout
 */
const HomeLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      {/* No Footer */}
    </div>
  );
};

export default HomeLayout;
